import store from '../store';

export const searchUsersPost = async () => {

    const restUrl = store.get("url");
    const clientId = store.get("clientId");
    const searchOption = store.get("searchOption");

    const url = `${restUrl}/${clientId}/api/search/users/search`;

    return await fetch(url,{
        method:"post",
        mode: "cors",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'application/json'
        },
        body: JSON.stringify(searchOption)
    }).then(response => {
        if (!response.ok) {
            throw Error(`${response.status} ${response.statusText}`);
        }
        return response;
    }).then(response => response.json())
};

export const searchUsersNext = async () => {

    const restUrl = store.get("url");
    const clientId = store.get("clientId");
    const searchOptionNext = store.get("searchOptionNext");

    const url = `${restUrl}/${clientId}/api/search/users/search`;
    return await fetch(url,{
        method:"post",
        mode: "cors",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'application/json'
        },
        body: JSON.stringify(searchOptionNext)
    }).then(response => {
        if (!response.ok) {
            throw Error(`${response.status} ${response.statusText}`);
        }
        return response;
    }).then(response => response.json())
};

export const searchDepartments = async () => {

    const restUrl = store.get("url");
    const clientId = store.get("clientId");
    const url = `${restUrl}/${clientId}/api/search/departments`;

    return await fetch(url,{
        method:"get",
        mode: "cors",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'application/json'
        }
    }).then(response => {
        if (!response.ok) {
            throw Error(`${response.status} ${response.statusText}`);
        }
        return response;
    }).then(response => response.json())
};

export const searchDepartmentId = async () => {
    const restUrl = store.get("url");
    const clientId = store.get("clientId");
    const departmentName = store.get("defaultDepartment").trim();
    const url = `${restUrl}/${clientId}/api/search/getdepartmentid`;
    const searchBody = {
        "DepartmentId": "",
        "Name": `${departmentName}`,
        "Sections": []
    };

    return await fetch(url,{
        method:"post",
        mode: "cors",
        headers:{
            'Content-Type': 'application/json',
            'Accept':'application/json'
        },
        body: JSON.stringify(searchBody)
    }).then(response => {
        if (!response.ok) {
            throw Error(`${response.status} ${response.statusText}`);
        }
        return response;
    }).then(response => response.json())
};